import { EditorUser, GenericProps } from "../../types";
import * as hooks from "../hooks";
import { UserRow } from "./UserRow";

export function UsersTable({ state, dispatch }: GenericProps) {

    const { visible: users } = useFilteredUsers(state.users.edits, state.filters.users)

    return <table className="table omnia-table users">

        <thead>
            <tr>
                <th colSpan={2}>Name</th>
                <th>Email</th>
                <th>Role</th>
            </tr>
        </thead>

        <tbody>
            {
                users.map(user => <UserRow key={user.userId} {...{ state, dispatch, user }} />)
            }
        </tbody>
    </table>

}

export function useFilteredUsers(users: EditorUser[], filter: string) {

    const select = (u: EditorUser) => ({
        name: u.displayName,
        email: u.email,
        shouldRetain: u.holdingRole !== u.initialState.holdingRole
    })

    return hooks.useFilteredUsers(users, filter, select)

}